module.exports = __webpack_public_path__ + "static/media/Costa Rica.8af4809c.png";